// frontend/src/api/certificacionesService.js
import api from './api';

const certificacionesService = {

  async crearSolicitud(datos) {
    const response = await api.post('/certificaciones', {
      tipo:          datos.tipo,
      especificacion: datos.especificacion || null,
      comentarios:   datos.comentarios    || null,
    });
    return response.data;
  },

  async getMisSolicitudes() {
    const response = await api.get('/certificaciones');
    return response.data;
  },

  async getTodasLasSolicitudes() {
    const response = await api.get('/certificaciones/admin');
    return response.data;
  },

  async actualizarEstado(certificacionID, estado) {
    const response = await api.patch(`/certificaciones/${certificacionID}/estado`, { estado });
    return response.data;
  },

  // Obtener variables del empleado para llenar la plantilla
  async getDatosEmpleado(certificacionID) {
    const response = await api.get(`/certificaciones/${certificacionID}/datos-empleado`);
    return response.data;
  },

  // Subir el PDF firmado
  async subirDocumentoFirmado(certificacionID, archivo) {
    const formData = new FormData();
    formData.append('documento', archivo);
    const response = await api.post(
      `/certificaciones/${certificacionID}/documento-firmado`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },
  // Plantillas
async getPlantillas(tipo = null) {
  const url = tipo ? `/plantillas-certificaciones?tipo=${tipo}` : '/plantillas-certificaciones';
  const response = await api.get(url);
  return response.data;
},

async crearPlantilla(datos) {
  const response = await api.post('/plantillas-certificaciones', datos);
  return response.data;
},

async actualizarPlantilla(id, datos) {
  const response = await api.put(`/plantillas-certificaciones/${id}`, datos);
  return response.data;
},

async eliminarPlantilla(id) {
  const response = await api.delete(`/plantillas-certificaciones/${id}`);
  return response.data;
},
};




export default certificacionesService;
